// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LocaleConstants$PorterinUtils from "../constants/LocaleConstants.mjs";
import * as CountryConstants$PorterinUtils from "../constants/CountryConstants.mjs";

function countryCodeFromLocale(locale) {
  if (locale === LocaleConstants$PorterinUtils.bn_BD || locale === LocaleConstants$PorterinUtils.en_BD) {
    return CountryConstants$PorterinUtils.bd;
  } else if (locale === LocaleConstants$PorterinUtils.en_AE) {
    return CountryConstants$PorterinUtils.ae;
  } else if (locale === LocaleConstants$PorterinUtils.en_TK || locale === LocaleConstants$PorterinUtils.en_TR || locale === LocaleConstants$PorterinUtils.tr_TR) {
    return CountryConstants$PorterinUtils.tr;
  } else if (locale === LocaleConstants$PorterinUtils.en_IN) {
    return CountryConstants$PorterinUtils.ind;
  } else {
    return CountryConstants$PorterinUtils.uae;
  }
}

function countryCodeFromLocaleForOms(locale) {
  if (locale === LocaleConstants$PorterinUtils.bn_BD || locale === LocaleConstants$PorterinUtils.en_BD) {
    return CountryConstants$PorterinUtils.bd;
  } else if (locale === LocaleConstants$PorterinUtils.en_AE) {
    return CountryConstants$PorterinUtils.uae;
  } else if (locale === LocaleConstants$PorterinUtils.en_TK || locale === LocaleConstants$PorterinUtils.en_TR || locale === LocaleConstants$PorterinUtils.tr_TR) {
    return CountryConstants$PorterinUtils.tr;
  } else if (locale === LocaleConstants$PorterinUtils.en_IN) {
    return CountryConstants$PorterinUtils.ind;
  } else {
    return CountryConstants$PorterinUtils.uae;
  }
}

function countryCodeFromLocaleForGa(locale) {
  if (locale === LocaleConstants$PorterinUtils.bn_BD || locale === LocaleConstants$PorterinUtils.en_BD) {
    return CountryConstants$PorterinUtils.gaBd;
  } else if (locale === LocaleConstants$PorterinUtils.en_AE) {
    return CountryConstants$PorterinUtils.gaUae;
  } else if (locale === LocaleConstants$PorterinUtils.en_TK || locale === LocaleConstants$PorterinUtils.en_TR || locale === LocaleConstants$PorterinUtils.tr_TR) {
    return CountryConstants$PorterinUtils.gaTr;
  } else if (locale === LocaleConstants$PorterinUtils.en_IN) {
    return CountryConstants$PorterinUtils.gaInd;
  } else {
    return CountryConstants$PorterinUtils.gaUae;
  }
}

function getLocalesFromCountryCode(country) {
  if (country === CountryConstants$PorterinUtils.ae) {
    return LocaleConstants$PorterinUtils.aeLocales;
  } else if (country === CountryConstants$PorterinUtils.bd) {
    return LocaleConstants$PorterinUtils.bdLocales;
  } else if (country === CountryConstants$PorterinUtils.tr) {
    return LocaleConstants$PorterinUtils.trLocales;
  } else if (country === CountryConstants$PorterinUtils.ind) {
    return LocaleConstants$PorterinUtils.indLocales;
  } else {
    return LocaleConstants$PorterinUtils.aeLocales;
  }
}

function getDefaultLocaleFromCountryCode(country) {
  if (country === CountryConstants$PorterinUtils.ae) {
    return LocaleConstants$PorterinUtils.uae_default;
  } else if (country === CountryConstants$PorterinUtils.bd) {
    return LocaleConstants$PorterinUtils.bd_default;
  } else if (country === CountryConstants$PorterinUtils.tr) {
    return LocaleConstants$PorterinUtils.tr_default;
  } else if (country === CountryConstants$PorterinUtils.ind) {
    return LocaleConstants$PorterinUtils.ind_default;
  } else {
    return LocaleConstants$PorterinUtils.uae_default;
  }
}

function getHostFromCountryCode(country) {
  if (country === CountryConstants$PorterinUtils.ae) {
    return "https://porter.ae";
  } else if (country === CountryConstants$PorterinUtils.bd) {
    return "https://porter.com.bd";
  } else if (country === CountryConstants$PorterinUtils.tr) {
    return "https://theporter.com.tr";
  } else if (country === CountryConstants$PorterinUtils.ind) {
    return "https://porter.in";
  } else {
    return "https://porter.ae";
  }
}

export {
  countryCodeFromLocale ,
  countryCodeFromLocaleForOms ,
  countryCodeFromLocaleForGa ,
  getLocalesFromCountryCode ,
  getDefaultLocaleFromCountryCode ,
  getHostFromCountryCode ,
}
/* No side effect */
